import React from "react";
import "./AiOutpaintControlMenu.css";

const PRESET_PADDINGS = [0, 128, 256, 512];
const OUTPUT_FORMATS = ["png", "webp", "jpg"];

const AiOutpaintControlMenu = ({ onApply, busy = false }) => {
  const [padding, setPadding] = React.useState(256);
  const [sides, setSides] = React.useState({
    left: true,
    right: true,
    up: true,
    down: true,
  });
  const [prompt, setPrompt] = React.useState("");
  const [outputFormat, setOutputFormat] = React.useState("png");

  const anySideEnabled = Object.values(sides).some(Boolean);

  const handleApply = () => {
    if (typeof onApply !== "function") return;
    const opts = {
      output_format: outputFormat,
    };
    if (sides.left) opts.left = padding;
    if (sides.right) opts.right = padding;
    if (sides.up) opts.up = padding;
    if (sides.down) opts.down = padding;
    if (prompt.trim()) opts.prompt = prompt.trim();
    onApply(opts);
  };

  const toggleSide = (side) => {
    setSides((prev) => ({ ...prev, [side]: !prev[side] }));
  };

  return (
    <div className="ai-outpaint-control-menu-container">
      <div className="ai-outpaint-field">
        <p className="ai-outpaint-field-label">Padding (px)</p>
        <div className="ai-outpaint-chip-row">
          {PRESET_PADDINGS.map((p) => (
            <button
              type="button"
              key={p}
              className={`ai-outpaint-chip ${padding === p ? "selected" : ""}`}
              onClick={() => setPadding(p)}
            >
              {p}
            </button>
          ))}
        </div>
        <input
          type="number"
          min={0}
          step={16}
          value={padding}
          onChange={(e) => setPadding(Math.max(0, parseInt(e.target.value, 10) || 0))}
          className="ai-outpaint-input"
        />
      </div>

      <div className="ai-outpaint-field">
        <p className="ai-outpaint-field-label">Sides</p>
        <div className="ai-outpaint-chip-row">
          {[
            { id: "up", label: "Top" },
            { id: "down", label: "Bottom" },
            { id: "left", label: "Left" },
            { id: "right", label: "Right" },
          ].map((s) => (
            <button
              type="button"
              key={s.id}
              className={`ai-outpaint-chip ${sides[s.id] ? "selected" : ""}`}
              onClick={() => toggleSide(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="ai-outpaint-field">
        <p className="ai-outpaint-field-label">Prompt (optional)</p>
        <textarea
          className="ai-outpaint-textarea"
          rows={3}
          placeholder="Describe what should fill the new area…"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </div>

      <div className="ai-outpaint-field">
        <p className="ai-outpaint-field-label">Output format</p>
        <select
          className="ai-outpaint-select"
          value={outputFormat}
          onChange={(e) => setOutputFormat(e.target.value)}
        >
          {OUTPUT_FORMATS.map((fmt) => (
            <option key={fmt} value={fmt}>
              {fmt.toUpperCase()}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        className="ai-outpaint-apply-btn"
        onClick={handleApply}
        disabled={busy || !anySideEnabled || padding <= 0}
      >
        {busy ? "Expanding…" : "Expand image"}
      </button>
    </div>
  );
};

export default AiOutpaintControlMenu;
